export default __webpack_public_path__ + "static/article-managing-your-bridal-party-51abc94b0fade719a3bb2c0507789388.jpg";